export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="px-6 md:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-warm-950">
            Perché Migliaia di Utenti Cercano{' '}
            <span className="text-tealwarm-600">Itaobuy Spreadsheet</span>
          </h2>
          <p className="mt-3 text-sm text-warm-500 max-w-xl mx-auto">
            Un metodo organizzato, veloce e affidabile per trovare i prodotti migliori con foto QC verificate.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-2 md:row-span-2 relative bg-cream-50 rounded-3xl overflow-hidden group cursor-default">
            <img
              src="https://readdy.ai/api/search-image?query=Top%20down%20flat%20lay%20of%20a%20smartphone%20displaying%20detailed%20close%20up%20product%20photos%20of%20sneakers%20side%20by%20side%20with%20a%20handwritten%20checklist%20on%20cream%20paper%20with%20a%20magnifying%20glass%20and%20a%20pen%2C%20warm%20desk%20lamp%20illumination%2C%20organized%20workspace%20aesthetic%20with%20a%20cup%20of%20espresso%20nearby%2C%20productivity%20and%20quality%20control%20concept%2C%20editorial%20photography&width=900&height=700&seq=feature-large-qc-v2&orientation=landscape"
              alt="Itaobuy QC foto verificate"
              className="w-full h-full object-cover object-top rounded-3xl"
            />
            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/50 to-transparent">
              <span className="inline-block px-3 py-1 rounded-full bg-tealwarm-500 text-white text-xs font-semibold mb-2">QC Verificato</span>
              <h3 className="text-xl font-bold text-white">Foto QC e Dettagli</h3>
              <p className="text-sm text-white/80 mt-1">Ogni prodotto include immagini reali per valutare la qualità prima dell&apos;acquisto.</p>
            </div>
          </div>

          <div className="bg-tealwarm-50 rounded-3xl p-6 md:p-7 flex flex-col justify-between">
            <div>
              <div className="w-12 h-12 rounded-2xl bg-tealwarm-100 flex items-center justify-center text-tealwarm-600 mb-4">
                <i className="ri-flashlight-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-warm-900">Risparmia Tempo</h3>
              <p className="text-sm text-warm-600 mt-2 leading-relaxed">
                Con itaobuy spreadsheet non devi più cercare manualmente. Tutti i prodotti sono già organizzati per categoria con link diretti.
              </p>
            </div>
            <div className="mt-4">
              <a href="/itaobuy-spreadsheet-come-usare" className="flex items-center gap-2 text-tealwarm-700 text-sm font-medium hover:text-tealwarm-800 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-right-line"></i>
                <span>Scopri di più</span>
              </a>
            </div>
          </div>

          <div className="bg-cream-100 rounded-3xl p-6 md:p-7 flex flex-col justify-between">
            <div>
              <div className="w-12 h-12 rounded-2xl bg-cream-200 flex items-center justify-center text-warm-700 mb-4">
                <i className="ri-shield-star-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-warm-900">Maggiore Controllo</h3>
              <p className="text-sm text-warm-600 mt-2 leading-relaxed">
                Analizza ogni dettaglio con le foto QC incluse nello spreadsheet. Confronta prezzi, qualità e venditori in un colpo d&apos;occhio.
              </p>
            </div>
            <div className="mt-4">
              <a href="/itaobuy-spreadsheet-sicurezza" className="flex items-center gap-2 text-warm-700 text-sm font-medium hover:text-warm-800 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-right-line"></i>
                <span>Vedi esempio</span>
              </a>
            </div>
          </div>

          <div className="bg-warm-50 rounded-3xl p-6 md:p-7 flex flex-col justify-between">
            <div>
              <div className="w-12 h-12 rounded-2xl bg-warm-100 flex items-center justify-center text-warm-600 mb-4">
                <i className="ri-global-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-warm-900">Guida in Italiano</h3>
              <p className="text-sm text-warm-600 mt-2 leading-relaxed">
                Tutte le informazioni sono in italiano, pensate per chi si avvicina per la prima volta al mondo itaobuy spreadsheet.
              </p>
            </div>
            <div className="mt-4">
              <a href="/itaobuy-spreadsheet-guida-completa" className="flex items-center gap-2 text-warm-600 text-sm font-medium hover:text-warm-700 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-right-line"></i>
                <span>Leggi la guida</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}